/* ================================================================
   teavity-a11y-fixes.js
   WCAG 2.1 AA Accessibility Enhancements
   Addresses: ARIA labels, keyboard nav, reduced-motion helpers
   ================================================================ */
(function () {
  'use strict';

  function removeSwiperPauseButtons() {
    document.querySelectorAll('.swiper-pause-btn').forEach(function (btn) {
      btn.remove();
    });
  }

  /* ---- Pause autoplaying carousels when off-screen ---- */
  function setupCarouselVisibilityPause() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var swiperEl = entry.target;
        var swiperInstance = swiperEl.swiper;
        if (!swiperInstance || !swiperInstance.autoplay) return;
        if (entry.isIntersecting) {
          swiperInstance.autoplay.start();
        } else {
          swiperInstance.autoplay.stop();
        }
      });
    }, { threshold: 0.25 });

    document.querySelectorAll('.swiper').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- ARIA labels for swiper navigation arrows ---- */
  function labelSwiperArrows() {
    document.querySelectorAll('.swiper-button-next').forEach(function (el) {
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Next slide');
        el.setAttribute('role', 'button');
      }
    });
    document.querySelectorAll('.swiper-button-prev').forEach(function (el) {
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Previous slide');
        el.setAttribute('role', 'button');
      }
    });
  }

  /* ---- Mark decorative SVG icons as aria-hidden ---- */
  function hideDecorativeSvgs() {
    document.querySelectorAll('svg:not([aria-label]):not([aria-hidden])').forEach(function (el) {
      // Only hide if the svg has no <title> child and is within an icon container
      if (!el.querySelector('title') && el.closest('.sec__icon-box-content-icon, .q_icon, .social-icons, .jdgm-star')) {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('focusable', 'false');
      }
    });
  }

  /* ---- Ensure all <main> gets skip-link target ---- */
  function ensureSkipTarget() {
    var main = document.getElementById('MainContent');
    if (main && !main.getAttribute('tabindex')) {
      main.setAttribute('tabindex', '-1');
    }
  }

  /* ---- Init on DOM ready and after Shopify section events ---- */
  function init() {
    removeSwiperPauseButtons();
    setupCarouselVisibilityPause();
    labelSwiperArrows();
    hideDecorativeSvgs();
    ensureSkipTarget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify editor loads new sections
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 200);
  });

  // Re-init after a delay for async swiper initialization
  window.addEventListener('load', function () {
    setTimeout(function () {
      removeSwiperPauseButtons();
      labelSwiperArrows();
    }, 1000);
  });
})();
